export default {
  header: {
    notes: 'Header in the mini cart when it has items',
    message: {
      zero: 'No items in cart',
      one: '1 item in cart',
      other: '{{count}} items in cart',
    },
  },
  missingDeliveryPointHelp: {
    notes:
      'Little i helptext displayed when there are cart items without a deliverypoint',
    message:
      'The cart also contains some items without a delivery address, please open the cart to view them.',
  },
};
